var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHuellaHover28X28(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01367 3.05581C6.01367 3.05581 13.9637 -1.55219 22.0757 3.05581",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25781 10.4656C2.25781 10.4656 6.45781 3.90756 14.5038 4.25556C22.5498 4.60356 25.7358 10.0636 25.7358 10.0636",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50147 22.7779C4.50147 22.7779 1.97547 16.3399 5.25747 12.0139C8.53947 7.68787 14.6415 5.20387 20.4675 9.57187C26.6415 14.2039 24.6435 19.5919 23.0415 20.4739C21.4395 21.3559 19.0155 21.3379 17.8455 18.7579C17.8455 18.7579 17.5395 18.0739 17.5215 16.9039C17.5035 15.7339 16.1115 13.9999 13.8795 14.1979C11.6475 14.3959 10.6275 15.9259 10.5015 17.2279C10.3755 18.5059 10.3515 24.6139 18.0735 26.9899",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9991 17.4614C13.9991 17.4614 13.9151 25.0754 22.7171 23.9834",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1619 26.8456C11.1619 26.8456 5.89392 21.7036 7.34592 15.5776C7.34592 15.5776 8.95393 11.1496 13.5019 10.9816C18.0499 10.8136 20.9059 13.1476 21.1999 17.7796",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuellaHover28X28);
export default __webpack_public_path__ + "static/media/HUELLA_HOVER_28X28.c65f400c9c706d4d6ea737c49e390acc.svg";
export { ForwardRef as ReactComponent };